import { render, staticRenderFns } from "./EducationalScheduleTimeAdd.vue?vue&type=template&id=6804e149&"
import script from "./EducationalScheduleTimeAdd.vue?vue&type=script&lang=js&"
export * from "./EducationalScheduleTimeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports